.modalContent {
  padding: var(--mirai-ui-space-M);
}
